import { ga, adjust } from 'js/analytics/adapters'

export const trackStartRegistration = () => {
  ga.track('start_registration')
  adjust.track('Start Registration')
}
